import angular from 'angular';
import loadingAdminFormComponent from './loading-admin-form.component';

export default angular.module('components.app.product.loadingAdminForm', [])
  .component('loadingAdminForm', loadingAdminFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/loading-admin-form/loading-admin-form.module.js